(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.DOT_PURPLE = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#9A51FF").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_PURPLE, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.DOT_ORGANGE = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#21AEFF").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_ORGANGE, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.DOT_GREEN = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#5CDDAD").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_GREEN, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.DOT_BLUE = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#7CECF8").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_BLUE, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.DARKBLUE = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#4105D2").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DARKBLUE, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.MRN = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DARK_BLUE
	this.instance = new lib.DARKBLUE();
	this.instance.setTransform(181.45,-108.2,0.8596,0.8596,0,0,0,0.3,0.5);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(235).to({_off:false},0).to({x:121.95,alpha:1},39,cjs.Ease.quintInOut).wait(110));

	// DARK_BLUE
	this.instance_1 = new lib.DARKBLUE();
	this.instance_1.setTransform(121.95,-108.2,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(31).to({x:181.45,alpha:0},38,cjs.Ease.quintInOut).to({_off:true},40).wait(83).to({_off:false,x:121.95,y:10.1,alpha:1},0).to({y:-49.1},43,cjs.Ease.quintInOut).wait(149));

	// DARK_BLUE
	this.instance_2 = new lib.DARKBLUE();
	this.instance_2.setTransform(121.95,-49.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(148).to({y:10.1},43,cjs.Ease.quintInOut).to({_off:true},1).wait(122).to({_off:false,x:180.6,y:10,alpha:0},0).to({x:121.95,alpha:1},38,cjs.Ease.quintInOut).wait(32));

	// DARK_BLUE
	this.instance_3 = new lib.DARKBLUE();
	this.instance_3.setTransform(121.95,10,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(31).to({x:180.6,alpha:0},38,cjs.Ease.quintInOut).to({_off:true},40).wait(83).to({_off:false,x:63.55,y:69.1,alpha:1},0).to({x:121.95},43,cjs.Ease.quintInOut).wait(149));

	// DARK_BLUE
	this.instance_4 = new lib.DARKBLUE();
	this.instance_4.setTransform(121.95,69.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.instance_5 = new lib.DOT_ORGANGE();
	this.instance_5.setTransform(63.25,-49,0.8596,0.8596,0,0,0,0.3,0.5);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(148).to({x:63.55},43,cjs.Ease.quintInOut).to({_off:true},1).wait(192));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(192).to({_off:false},0).wait(160).to({y:-108.2},31,cjs.Ease.quintInOut).wait(1));

	// DOT_ORGANGE
	this.instance_6 = new lib.DOT_ORGANGE();
	this.instance_6.setTransform(63.25,-108.2,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({y:-49},31,cjs.Ease.quintInOut).wait(161).to({x:64.3,y:10.1},0).wait(43).to({x:121.9},39,cjs.Ease.quintInOut).wait(40).to({x:63.25},38,cjs.Ease.quintInOut).to({y:-49.1},31,cjs.Ease.quintInOut).wait(1));

	// DOT_ORGANGE
	this.instance_7 = new lib.DOT_ORGANGE();
	this.instance_7.setTransform(63.25,-49.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).to({y:10.1},31,cjs.Ease.quintInOut).to({x:121.9},38,cjs.Ease.quintInOut).wait(40).to({x:64.3},39,cjs.Ease.quintInOut).wait(44).to({x:4.85,y:69.2},0).to({x:63.25},43,cjs.Ease.quintInOut).wait(117).to({y:10},31,cjs.Ease.quintInOut).wait(1));

	// DOT_ORGANGE
	this.instance_8 = new lib.DOT_ORGANGE();
	this.instance_8.setTransform(63.25,10,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({y:69.2},31,cjs.Ease.quintInOut).wait(117).to({x:4.85},43,cjs.Ease.quintInOut).wait(1).to({y:128.3},0).to({x:63.25},43,cjs.Ease.quintInOut).wait(117).to({y:69.1},31,cjs.Ease.quintInOut).wait(1));

	// DOT_ORGANGE
	this.instance_9 = new lib.DOT_ORGANGE();
	this.instance_9.setTransform(63.25,69.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.instance_10 = new lib.DOT_PURPLE();
	this.instance_10.setTransform(122.5,-49,0.8596,0.8596,0,0,0,0.3,0.5);
	this.instance_10._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_9).to({y:128.3},31,cjs.Ease.quintInOut).wait(117).to({x:4.85},43,cjs.Ease.quintInOut).to({_off:true},1).wait(192));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(192).to({_off:false},0).to({y:-108.2},43,cjs.Ease.quintInOut).to({x:64.1},39,cjs.Ease.quintInOut).wait(40).to({x:4.6},38,cjs.Ease.quintInOut).wait(32));

	// DOT_PURPLE
	this.instance_11 = new lib.DOT_PURPLE();
	this.instance_11.setTransform(4.6,-108.2,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(31).to({x:64.1},38,cjs.Ease.quintInOut).wait(40).to({x:122.5},39,cjs.Ease.quintInOut).to({y:-49},43,cjs.Ease.quintInOut).wait(1).to({x:63,y:-108.3},0).wait(43).to({x:4.6},39,cjs.Ease.quintInOut).to({y:-49.1},40,cjs.Ease.quintInOut).wait(70));

	// DOT_PURPLE
	this.instance_12 = new lib.DOT_PURPLE();
	this.instance_12.setTransform(4.6,-49.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(69).to({y:-108.3},40,cjs.Ease.quintInOut).to({x:63},39,cjs.Ease.quintInOut).wait(44).to({x:5.65,y:10},0).wait(43).to({x:63.25},39,cjs.Ease.quintInOut).wait(40).to({x:4.6},38,cjs.Ease.quintInOut).wait(32));

	// DOT_PURPLE
	this.instance_13 = new lib.DOT_PURPLE();
	this.instance_13.setTransform(4.6,10,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(31).to({x:63.25},38,cjs.Ease.quintInOut).wait(40).to({x:5.65},39,cjs.Ease.quintInOut).wait(44).to({x:-53,y:9.9},0).wait(43).to({x:4.6},39,cjs.Ease.quintInOut).to({y:69.1},40,cjs.Ease.quintInOut).wait(70));

	// DOT_PURPLE
	this.instance_14 = new lib.DOT_PURPLE();
	this.instance_14.setTransform(4.6,69.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.instance_15 = new lib.DOT_BLUE();
	this.instance_15.setTransform(4.35,-107.9,0.8596,0.8596,0,0,0,0.3,0.5);
	this.instance_15._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(69).to({y:9.9},40,cjs.Ease.quintInOut).to({x:-53},39,cjs.Ease.quintInOut).wait(43).to({_off:true},1).wait(192));
	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(192).to({_off:false},0).wait(43).to({x:-54.05},39,cjs.Ease.quintInOut).to({y:-167.4},40,cjs.Ease.quintInOut).wait(38).to({y:-108.2},31,cjs.Ease.quintInOut).wait(1));

	// DOT_BLUE
	this.instance_16 = new lib.DOT_BLUE();
	this.instance_16.setTransform(-54.05,-108.2,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({y:-167.4},31,cjs.Ease.quintInOut).wait(38).to({y:-107.9},40,cjs.Ease.quintInOut).to({x:4.35},39,cjs.Ease.quintInOut).wait(44).to({x:5.45,y:-167.5},0).wait(82).to({y:-108.3},40,cjs.Ease.quintInOut).to({x:-54.05},38,cjs.Ease.quintInOut).to({y:-49.1},31,cjs.Ease.quintInOut).wait(1));

	// DOT_BLUE
	this.instance_17 = new lib.DOT_BLUE();
	this.instance_17.setTransform(-54.05,-49.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({y:-108.3},31,cjs.Ease.quintInOut).to({x:5.45},38,cjs.Ease.quintInOut).to({y:-167.5},40,cjs.Ease.quintInOut).wait(83).to({x:-111.65,y:10.3},0).wait(43).to({x:-54.05},39,cjs.Ease.quintInOut).to({y:-49.2},40,cjs.Ease.quintInOut).wait(38).to({y:10},31,cjs.Ease.quintInOut).wait(1));

	// DOT_BLUE
	this.instance_18 = new lib.DOT_BLUE();
	this.instance_18.setTransform(-54.05,10,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({y:-49.2},31,cjs.Ease.quintInOut).wait(38).to({y:10.3},40,cjs.Ease.quintInOut).to({x:-111.65},39,cjs.Ease.quintInOut).wait(44).to({x:4.6,y:-49.3},0).wait(82).to({y:9.9},40,cjs.Ease.quintInOut).to({x:-54.05},38,cjs.Ease.quintInOut).to({y:69.1},31,cjs.Ease.quintInOut).wait(1));

	// DOT_BLUE
	this.instance_19 = new lib.DOT_BLUE();
	this.instance_19.setTransform(-54.05,69.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.instance_20 = new lib.DOT_GREEN();
	this.instance_20.setTransform(-54.3,-107.9,0.8596,0.8596,0,0,0,0.3,0.5);
	this.instance_20._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({y:9.9},31,cjs.Ease.quintInOut).to({x:4.6},38,cjs.Ease.quintInOut).to({y:-49.3},40,cjs.Ease.quintInOut).wait(82).to({_off:true},1).wait(192));
	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(192).to({_off:false},0).wait(43).to({x:-112.7},39,cjs.Ease.quintInOut).to({y:-167.4},40,cjs.Ease.quintInOut).wait(38).to({y:-108.2},31,cjs.Ease.quintInOut).wait(1));

	// DOT_GREEN
	this.instance_21 = new lib.DOT_GREEN();
	this.instance_21.setTransform(-112.7,-108.2,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({y:-167.4},31,cjs.Ease.quintInOut).wait(38).to({y:-107.9},40,cjs.Ease.quintInOut).to({x:-54.3},39,cjs.Ease.quintInOut).wait(44).to({x:-53.2,y:-48.8},0).wait(82).to({y:-108.3},40,cjs.Ease.quintInOut).to({x:-112.7},38,cjs.Ease.quintInOut).to({y:-49.1},31,cjs.Ease.quintInOut).wait(1));

	// DOT_GREEN
	this.instance_22 = new lib.DOT_GREEN();
	this.instance_22.setTransform(-112.7,-49.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_22).to({y:-108.3},31,cjs.Ease.quintInOut).to({x:-53.2},38,cjs.Ease.quintInOut).to({y:-48.8},40,cjs.Ease.quintInOut).wait(83).to({x:-112.7,y:-49.2},0).wait(160).to({y:10},31,cjs.Ease.quintInOut).wait(1));

	// DOT_GREEN
	this.instance_23 = new lib.DOT_GREEN();
	this.instance_23.setTransform(-112.7,10,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({y:-49.2},31,cjs.Ease.quintInOut).wait(161).to({x:-54.05,y:69.4},0).wait(82).to({y:9.9},40,cjs.Ease.quintInOut).to({x:-112.7},38,cjs.Ease.quintInOut).to({y:69.1},31,cjs.Ease.quintInOut).wait(1));

	// DOT_GREEN
	this.instance_24 = new lib.DOT_GREEN();
	this.instance_24.setTransform(-112.7,69.1,0.8596,0.8596,0,0,0,0.3,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_24).to({y:9.9},31,cjs.Ease.quintInOut).to({x:-54.05},38,cjs.Ease.quintInOut).to({y:69.4},40,cjs.Ease.quintInOut).wait(82).to({_off:true},1).wait(192));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-137.3,-192.3,343.20000000000005,344.8);


// stage content:
(lib.NMI_Modular_Dots_15sec_MRN = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.MRN("synched",0);
	this.instance.setTransform(184.6,220.2,1,1,0,0,0,-5.5,-5.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(384));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(247.8,258.4,148.2,119.80000000000001);
// library properties:
lib.properties = {
	id: '5FC7015F98B8444E9102965EF833CF0A',
	width: 390,
	height: 450,
	fps: 18,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['5FC7015F98B8444E9102965EF833CF0A'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;



var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
function init() {
	canvas = document.getElementById("canvas");
	anim_container = document.getElementById("animation_container");
	dom_overlay_container = document.getElementById("dom_overlay_container");
	var comp=AdobeAn.getComposition("5FC7015F98B8444E9102965EF833CF0A");
	var lib=comp.getLibrary();
	handleComplete({},comp);
}
function handleComplete(evt,comp) {
	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
	var lib=comp.getLibrary();
	var ss=comp.getSpriteSheet();
	exportRoot = new lib.NMI_Modular_Dots_15sec_MRN();
	stage = new lib.Stage(canvas);	
	//Registers the "tick" event listener.
	fnStartAnimation = function() {
		stage.addChild(exportRoot);
		createjs.Ticker.framerate = lib.properties.fps;
		createjs.Ticker.addEventListener("tick", stage);
	}	    
	//Code to support hidpi screens and responsive scaling.
	AdobeAn.makeResponsive(false,'both',false,1,[canvas,anim_container,dom_overlay_container]);	
	AdobeAn.compositionLoaded(lib.properties.id);
	fnStartAnimation();
}
$(window).on("scriptload", init);